var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-button-bar col-12 mb-3"},[_c('div',{staticClass:"row d-none d-md-block print-button-container ml-1"},[_c('button',{staticClass:"col-sm-2 print-buttton px-2",on:{"click":_vm.print}},[_vm._v("印刷する")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }